module.exports = __webpack_public_path__ + "static/media/teachers-02.bb7ed4ed.png";